import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import Navbar from "../components/navbar";
import { NavLink } from "react-router-dom";
import mainLoan from "../Assests/loan-main-page.jpg";
import Main2 from '../Assests/main2.jpeg'
import WhatsAppButton from "../components/WhatsAppButton";
import emiratesislamicbank from '../Assests/emirates-islamic-bank.jpeg'
import dubaiislamic from '../Assests/Dubai-Islamic-Bank.png'
import deem from '../Assests/Deem-Finance.jpeg'
import rak from '../Assests/RAK-Bank.png'
import adcb from '../Assests/ADCB-Bank.png'
import fab from '../Assests/FAB-Bank.jpeg'
import adib from '../Assests/ADIB-Bank.jpeg'
import citi from '../Assests/Citi-Bank.png'



const MainPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);


  return (
    <div
      id="home"
      className="relative min-h-screen bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50"
    >
      <Navbar />

      {/* Main Hero Section */}
      <div className="relative z-10 flex items-center min-h-[100vh] px-6 lg:px-12 pt-20">
        <div className="max-w-7xl mx-auto w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div
              className={`space-y-6 transition-all duration-1000 ${isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
                }`}
            >
              <div className="space-y-4">
                <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
                  Easy & Trusted Loan Solutions
                  <span className="bg-gradient-to-r from-emerald-400 via-teal-500 to-green-400 bg-clip-text text-transparent">
                    &nbsp; For Everyone
                  </span>
                </h1>

                <h2 className="text-2xl font-semibold text-gray-800">
                  Get quick approval. Flexible repayment. 100% secure.
                </h2>

                <p className="text-base lg:text-lg text-gray-700 max-w-lg leading-relaxed">
                  We guarantee a hassle-free loan experience with approvals in
                  just a few minutes. Your trusted partner in financial needs.
                </p>
              </div>

              {/* CTA Button */}
              <div className="pt-2">
                <NavLink to="/checkout">
                  <button className="group inline-flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-full text-base lg:text-lg font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-emerald-500/25">
                    Apply For Loan
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                  </button>
                </NavLink>
              </div>
            </div>

            {/* Right image */}
            <div
              className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-500 ${isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
                }`}
            >
              <div className="relative">
                <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden flex items-center justify-center shadow-xl border-4 border-white">
                  <img
                    src={mainLoan}
                    alt="Loan Services"
                    className="object-cover w-full h-full"
                  />
                </div>
                <div className="absolute inset-0 w-80 h-80 lg:w-96 lg:h-96 rounded-full bg-gradient-to-br from-emerald-300/40 via-teal-300/30 to-green-300/40 blur-xl scale-110 animate-pulse"></div>
              </div>
            </div>
          </div>

          <WhatsAppButton size={28} />

        </div>
      </div>

      {/* ================================
          WHY CHOOSE US
      ================================== */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-emerald-700">
            Why Choose LoanFinder?
          </h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
            We make finding the right loan simple, fast, and transparent.
            Whether you need a personal loan or business loan, LoanFinder
            connects you with the best offers in the UAE.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mt-12">
            {[
              {
                title: "Expert Guidance",
                desc: "Get personalized loan recommendations from UAE experts.",
              },
              {
                title: "Quick Approvals",
                desc: "Fast application processing to get your funds instantly.",
              },
              {
                title: "Trusted Partners",
                desc: "We work with UAE’s leading banks to offer exclusive deals.",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="p-6 bg-emerald-50 rounded-xl shadow-md hover:shadow-lg transition"
              >
                <h3 className="font-bold text-xl text-emerald-700 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================================
          HOW IT WORKS
      ================================== */}
      <section className="py-16 px-6 lg:px-12 bg-gradient-to-br from-emerald-50 via-teal-50 to-green-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          {/* Steps */}
          <div className="space-y-8">
            <h2 className="text-3xl font-bold text-emerald-700">
              How It Works?
            </h2>
            {[
              {
                step: "Submit Your Details",
                desc: "Fill out our quick eligibility form — it takes just a minute!",
              },
              {
                step: "We Connect with Banks",
                desc: "We share your information securely with trusted UAE banks.",
              },
              {
                step: "Banks Reach Out",
                desc: "Banks contact you directly with the best offers to choose from.",
              },
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center bg-emerald-500 text-white font-bold rounded-full">
                  {idx + 1}
                </div>
                <div>
                  <h4 className="font-semibold text-lg text-emerald-700">
                    {item.step}
                  </h4>
                  <p className="text-gray-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-lg border-4 border-white">
              <img
                src={Main2}
                alt="How it works"
                className="object-content w-full h-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ================================
          BANKS
      ================================== */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-emerald-700">
            Top Banks We Work With
          </h2>
          <p className="text-gray-600 mt-3">
            We compare almost every bank in the United Arab Emirates.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
            {[
              { name: "Emirates Islamic", img: emiratesislamicbank },
              { name: "Dubai Islamic Bank", img: dubaiislamic },
              { name: "Deem Finance", img: deem },
              { name: "RAK Bank", img: rak },
              { name: "ADCB Bank", img: adcb },
              { name: "FAB Bank", img: fab },
              { name: "ADIB Bank", img: adib },
              { name: "Citi Bank", img: citi },
            ].map((bank, idx) => (
              <div
                key={idx}
                className="p-6 bg-emerald-50 rounded-lg shadow hover:shadow-md transition flex flex-col items-center"
              >
                <img
                  src={bank.img}
                  alt={bank.name}
                  className="w-24 h-24 object-contain mb-3 rounded-full border border-emerald-200 shadow-sm bg-white p-2"
                />
                <p className="text-emerald-700 font-semibold text-sm text-center">
                  {bank.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>




      {/* ✅ Representative Illustration Section */}
      <section className="py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-emerald-700 mb-6">
            Representative Illustration
          </h2>

          {/* Info Table */}
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-200 rounded-lg shadow-md bg-white">
              <tbody>
                <tr className="border-b">
                  <td className="p-4 font-semibold text-gray-700">Repayment Period</td>
                  <td className="p-4 text-gray-600">6 to 48 months</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4 font-semibold text-gray-700">Maximum APR</td>
                  <td className="p-4 text-gray-600">Up to 24% per annum</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4 font-semibold text-gray-700">Processing Fee</td>
                  <td className="p-4 text-gray-600">1.05% of loan amount</td>
                </tr>
                <tr>
                  <td className="p-4 font-semibold text-gray-700">
                    Representative Example
                  </td>
                  <td className="p-4 text-gray-600">
                    AED 50,000 for 24 months at 14% p.a. + 1.05% fee ≈ Total Cost AED
                    64,160, Monthly AED 2,673
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Disclaimer */}
          <p className="mt-6 text-sm text-gray-500 leading-relaxed">
            This is a representative example for illustration only. Actual terms and
            costs may vary depending on your lender.
          </p>
          <p className="mt-2 text-xs text-gray-400">
            Disclaimer: <span className="font-semibold">AE Finance</span> is an
            independent platform. We do not grant loans — we connect customers with
            licensed UAE banks and financial institutions. Final loan amounts,
            interest rates, fees, and eligibility are decided by the lender. We do not
            charge you any application fee but may receive a referral commission from
            banks or agents.
          </p>
        </div>
      </section>

      {/* ✅ Footer */}
      <footer className="bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50 py-10 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo + About */}
          <div>
            <h3 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">AE Finance</h3>
            <p className="mt-3 text-sm text-gray-400 leading-relaxed">
              Your trusted partner for finding the best loan and credit card deals in
              the UAE. We connect you with top banks and financial institutions to
              make borrowing simple and transparent.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">Contact Us</h4>
            <p className="text-sm text-gray-400">Email: aft4417@gmail.com</p>
            <p className="text-sm text-gray-400">Phone: +971558720718</p>
            <p className="text-sm text-gray-400 mt-2">
              Jebel Ali Free Zone · Street: Po Box 27074. City: Abu Dhabi
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} AE Finance. All Rights Reserved.
        </div>
      </footer>


    </div>
  );
};

export default MainPage;
